//import style global sheet
import '@moeindal/base-raiko-panel-components/dist/cjs/index.css';

import './style/App.css';
import './style/Font.css';
import './style/Scrollbar.css';
import './style/TextFieldStyle.css'
import './style/CustomizeComponents.css'
import './style/FlexStyle.css'
import './style/TableStyle.css'
import "./style/Containers.css"
import "./style/ModalStyleSheet.css"
import "./style/SelectStyleSheet.css"
import "./style/ButtonStyleSheet.css"
import "./style/Dialog.css"
import "./style/StepperStyle.css"


//import library
import {create} from 'jss';
import rtl from 'jss-rtl';
import {StylesProvider, jssPreset} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/core/styles';
import {Navigate, Route, Routes} from "react-router-dom";
import CustomTheme from "./theme/CustomTheme";
import Login from "./pages/login/Login";
import PrivateRoute from "./route/PrivateRoute";
import React from "react";
import ForgetPassword from "./pages/ForgetPassword/ForgetPassword";
import ConfirmPhoneNumber from "./pages/ConfirmPhoneNumber/ConfirmPhoneNumber";
import {RouteInfo} from "./route/RouteHelper";
import Dashboard from "./pages/Dashboard/Dashboard";

import {prefixer} from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import {CacheProvider} from "@emotion/react";


// Configure JSS
const jss = create({plugins: [...jssPreset().plugins, rtl()]});

const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin]
});

function App() {
    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={CustomTheme}>
                <StylesProvider jss={jss}>
                    <Routes>
                        <Route element={<Login/>} path={RouteInfo.Login.url}/>
                        <Route element={<ForgetPassword/>} path={RouteInfo.ForgetPassword.url}/>
                        <Route element={<ConfirmPhoneNumber/>} path={RouteInfo.ConfirmPhoneNumber.url}/>
                        <Route element={<Dashboard/>} path={"dashboard"}/>

                        {/*<Route element={ <SuperAdmin/>} path={RouteInfo.Root.url}/>*/}
                        <Route
                            path='/panel/*'
                            element={
                                <PrivateRoute/>
                            }
                        />
                        <Route path="*" element={<Navigate replace to="/panel/"/>}/>
                    </Routes>
                </StylesProvider>
            </ThemeProvider>
        </CacheProvider>
    );
}

export default App;
